import { BROADCAST_TOGGLE_OVERLAY_STATUS } from 'actions/Types';
import { toggleOverlayStatus } from '../utils';
/**
 * Handles the syncing of hidden status of overlays through the toggling of the eye-ball icon.
 *
 * @param - backgroundId - the id of the background to toggle.
 */
export default overlayId => {
  return (dispatch, getState) => {
    const { overlays } = getState();
    const updatedOverlays = toggleOverlayStatus(overlayId, overlays);

    const action = {
      type: BROADCAST_TOGGLE_OVERLAY_STATUS,
      payload: updatedOverlays
    };
    dispatch(action);
  };
};
